var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "white",
    stroke: "#6191EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 7.66671V18.6667C11.334 19.1529 11.5271 19.6193 11.871 19.9631C12.2148 20.3069 12.6811 20.5 13.1673 20.5H20.5007C20.9869 20.5 21.4532 20.3069 21.797 19.9631C22.1408 19.6193 22.334 19.1529 22.334 18.6667V10.6385C22.334 10.3943 22.2851 10.1525 22.1904 9.92743C22.0956 9.70233 21.9568 9.49843 21.7822 9.32771L18.7434 6.35587C18.4009 6.02098 17.9409 5.83343 17.4619 5.83337H13.1673C12.6811 5.83337 12.2148 6.02653 11.871 6.37034C11.5271 6.71416 11.334 7.18048 11.334 7.66671V7.66671Z",
    stroke: "#6191EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 20.5001V22.3334C18.667 22.8196 18.4738 23.286 18.13 23.6298C17.7862 23.9736 17.3199 24.1668 16.8337 24.1668H9.50033C9.0141 24.1668 8.54778 23.9736 8.20396 23.6298C7.86015 23.286 7.66699 22.8196 7.66699 22.3334V12.2501C7.66699 11.7639 7.86015 11.2975 8.20396 10.9537C8.54778 10.6099 9.0141 10.4167 9.50033 10.4167H11.3337",
    stroke: "#6191EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy_icon.abed9ef8.svg";
export { ForwardRef as ReactComponent };